// Video Banner #2 JavaScript - Modal Version
(function () {
  "use strict";

  // Initialize video banner functionality
  function initVideoBanner() {
    const videoBanners = document.querySelectorAll(".tpt-video-banner-2");

    videoBanners.forEach((banner) => {
      const secondaryVideoContainer = banner.querySelector(
        ".tpt-video-banner-2_secondary-video"
      );
      const secondaryVideo = banner.querySelector(
        ".tpt-video-banner-2_secondary-video-element"
      );
      const modal = document.getElementById("videoModal");

      if (secondaryVideoContainer && secondaryVideo && modal) {
        // Set initial state - paused
        secondaryVideo.pause();

        // Add hover event listeners for secondary video preview
        secondaryVideoContainer.addEventListener("mouseenter", function () {
          playVideoPreview(secondaryVideo);
        });

        secondaryVideoContainer.addEventListener("mouseleave", function () {
          pauseVideoPreview(secondaryVideo);
        });

        // Add click event to open modal
        secondaryVideoContainer.addEventListener("click", function (e) {
          e.preventDefault();
          openVideoModal(modal);
        });

        // Prevent default video controls interaction
        secondaryVideo.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }

      // Handle main video - Shopify videos with autoplay
      const mainVideo = banner.querySelector(
        ".tpt-video-banner-2_main-video-element"
      );
      if (mainVideo) {
        // Ensure video is muted for autoplay to work
        mainVideo.muted = true;

        // Attempt to play the main video after a short delay
        setTimeout(() => {
          const playPromise = mainVideo.play();
          if (playPromise !== undefined) {
            playPromise.catch((error) => {
              console.log("Main video autoplay was prevented:", error);
              // Fallback: try to play on user interaction
              document.addEventListener(
                "click",
                function playOnInteraction() {
                  mainVideo
                    .play()
                    .catch((e) => console.log("Video play failed:", e));
                  document.removeEventListener("click", playOnInteraction);
                },
                { once: true }
              );
            });
          }
        }, 100);

        // Handle video load events
        mainVideo.addEventListener("loadeddata", function () {
          console.log("Main video loaded successfully");
        });

        mainVideo.addEventListener("error", function (e) {
          console.log("Main video error:", e);
        });
      }
    });

    // Initialize modal functionality
    initVideoModal();
  }

  // Initialize video modal functionality
  function initVideoModal() {
    const modal = document.getElementById("videoModal");
    if (!modal) return;

    const modalVideo = modal.querySelector(
      ".tpt-video-banner-2_modal-video-element"
    );
    const closeButtons = modal.querySelectorAll("[data-modal-close]");

    // Close modal event listeners
    closeButtons.forEach((button) => {
      button.addEventListener("click", function () {
        closeVideoModal(modal, modalVideo);
      });
    });

    // Close modal on ESC key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("active")) {
        closeVideoModal(modal, modalVideo);
      }
    });

    // Prevent modal content click from closing modal
    const modalContent = modal.querySelector(
      ".tpt-video-banner-2_modal-content"
    );
    if (modalContent) {
      modalContent.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    }
  }

  // Play secondary video preview (muted, for hover effect)
  function playVideoPreview(video) {
    if (video && video.paused) {
      // Ensure video is muted for preview
      video.muted = true;

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.log("Secondary video preview play was prevented:", error);
        });
      }
    }
  }

  // Pause secondary video preview
  function pauseVideoPreview(video) {
    if (video && !video.paused) {
      video.pause();
      // Reset to beginning for next hover
      video.currentTime = 0;
    }
  }

  // Open video modal
  function openVideoModal(modal) {
    if (!modal) return;

    const modalVideo = modal.querySelector(
      ".tpt-video-banner-2_modal-video-element"
    );

    // Add active class to show modal
    modal.classList.add("active");

    // Prevent body scroll
    document.body.style.overflow = "hidden";

    // Play modal video with sound
    if (modalVideo) {
      modalVideo.muted = false;
      modalVideo.currentTime = 0;

      const playPromise = modalVideo.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.log("Modal video play was prevented:", error);
        });
      }
    }

    // Focus management for accessibility
    const closeButton = modal.querySelector(".tpt-video-banner-2_modal-close");
    if (closeButton) {
      closeButton.focus();
    }
  }

  // Close video modal
  function closeVideoModal(modal, modalVideo) {
    if (!modal) return;

    // Remove active class to hide modal
    modal.classList.remove("active");

    // Restore body scroll
    document.body.style.overflow = "";

    // Pause and reset modal video
    if (modalVideo) {
      modalVideo.pause();
      modalVideo.currentTime = 0;
      modalVideo.muted = true;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initVideoBanner);
  } else {
    initVideoBanner();
  }

  // Re-initialize when new content is loaded (for Shopify theme sections)
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target.querySelector(".tpt-video-banner-2")) {
      setTimeout(initVideoBanner, 100);
    }
  });

  // Handle section unload
  document.addEventListener("shopify:section:unload", function (event) {
    const videos = event.target.querySelectorAll("video");
    videos.forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });

    // Close modal if open
    const modal = document.getElementById("videoModal");
    if (modal && modal.classList.contains("active")) {
      closeVideoModal(
        modal,
        modal.querySelector(".tpt-video-banner-2_modal-video-element")
      );
    }
  });

  // Handle intersection observer for performance optimization
  if ("IntersectionObserver" in window) {
    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const mainVideo = entry.target.querySelector(
            ".tpt-video-banner-2_main-video-element"
          );
          if (mainVideo) {
            if (entry.isIntersecting) {
              // Play main video when in viewport
              if (mainVideo.paused) {
                const playPromise = mainVideo.play();
                if (playPromise !== undefined) {
                  playPromise.catch((error) => {
                    console.log("Video autoplay was prevented:", error);
                  });
                }
              }
            } else {
              // Pause main video when out of viewport to save bandwidth
              if (!mainVideo.paused) {
                mainVideo.pause();
              }
            }
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      }
    );

    // Observe all video banners
    function observeVideos() {
      const videoBanners = document.querySelectorAll(".tpt-video-banner-2");
      videoBanners.forEach((banner) => {
        videoObserver.observe(banner);
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", observeVideos);
    } else {
      observeVideos();
    }
  }
})();
